import cookieManagerHelper from 'Helpers/cookies';
import store from '../app/store';

const getCountryConfig = config => {
    return (config && config.location && config.location.country) ? config.location.country : {};
};

const getSessionFeatures = () => {
    const state = store.getState();

    return cookieManagerHelper.readCookie('sf') || state.api.sessionFeatures || [];
};

export {
    getCountryConfig,
    getSessionFeatures
};
